const adaptHGestionAsistencial = (gestionAsistencial) => {
  const {
    idEvaluacion,
    razonSocial,
    cod_SAP,
    idEstadoPaciente,
    cantconx,
    fechaDesde,
    fechaHasta,
    idPaciente,
    paciente,
    sexo,
    edad,
    plan,
    nombrePlan,
    programa,
    codigoSAPCliente
  } = gestionAsistencial;

  const hasConnections = cantconx >= 1;

  return {
    contrato: idEvaluacion,
    hc: idPaciente,
    pacienteSAP: cod_SAP,
    paciente,
    edad,
    clienteSAP: codigoSAPCliente,
    nombreCliente: razonSocial,
    idPlan: plan,
    nombrePlan,
    programa,
    fechaDesde,
    fechaHasta,
    cx: hasConnections,
    sexo,
    idEstadoPaciente
  };
};

export const adaptGestionAsistencialArray = (adaptGestionAsistencialArray) => {
  return (
    structuredClone(
      adaptGestionAsistencialArray?.allGestionPacientesAsistencial
    )?.map((paciente) => adaptHGestionAsistencial(paciente)) || []
  );
};
